import React from 'react';
import Helmet from 'react-helmet';

import { SEOProps } from './SEO.types';

export function SEO({ title, description, url, image }: SEOProps) {
  return (
    <Helmet>
      {!!title && <title>{title}</title>}
      {!!description && <meta name="description" content={description} />}
      {!!image && <meta name="image" content={image} />}
      {!!url && <meta property="og:url" content={url} />}
      {!!title && <meta property="og:title" content={title} />}
      {!!description && <meta property="og:description" content={description} />}
      {!!image && <meta property="og:image" content={image} />}
    </Helmet>
  );
}
